import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DsModalComponent, Sterownik } from 'design-system';
import { catchError, takeUntil } from 'rxjs/operators';
import { DateHelper } from 'src/app/helpers/dateHelper';
import { StatusSubskrypcji } from 'src/app/models/status-subskrypcji.enum';
import { SubskrypcjeTabela } from 'src/app/models/subskrypcje-tabela.model';
import { WszystkieSubskrypcjeTabela } from 'src/app/models/wszystkie-subskrypcje.model';
import { EformsService } from 'src/app/services/eforms.service';
import { FormGroupService } from 'src/app/services/form-group.service';
import { FormMapService } from 'src/app/services/form-map.service';
import { NewsletterService } from 'src/app/services/newsletter.service';
import { DestroyComponent } from '../destroy/destroy.component';
import { DataFilterSubskrypcjeService } from 'src/app/services/data-filter-subskrypcje.service';
import { environment } from 'src/environments/environment';
import { EncryptionService } from 'src/app/services/encryption.service';
import { SubskrypcjeFiltr, SubskrypcjeFiltrModel } from 'src/app/models/subskrypcje-filtr.model';
import { of } from 'rxjs';

@Component({
  selector: 'app-subskrypcje-tabela',
  templateUrl: './subskrypcje-tabela.component.html',
  styleUrls: ['./subskrypcje-tabela.component.scss']
})
export class SubskrypcjeTabelaComponent extends DestroyComponent implements OnInit {
  @ViewChild('monitorowanieModal', { static: true }) monitorowanieModalContainer: DsModalComponent;
  @ViewChild('wyszukiwarkaModal', { static: true }) wyszukiwarkaModalContainer: DsModalComponent;
  @ViewChild('odwolanieModal', { static: true }) odwolanieModalModalContainer: DsModalComponent;
  sterownik: Sterownik;
  sterownikSzczegoly: Sterownik;
  tableData: WszystkieSubskrypcjeTabela[] = [];
  previousTableData: WszystkieSubskrypcjeTabela[] = [];
  dataAllSub: WszystkieSubskrypcjeTabela[] = [];
  formatDate = DateHelper.FORMAT_DATE;
  monitorowaniePodmiotuForm: FormGroup;
  wyszukiwarkaForm: FormGroup;
  selectedKrs: string = null;
  selectedStatus: string = null;
  subskrybcjaId: string = null;
  dialogOpened = false;
  action: string = null;
  statusSubskrypcji = StatusSubskrypcji;
  saveDisabled: boolean = false;

  constructor(
    private formMapService: FormMapService,
    private newsletterService: NewsletterService,
    private formGroupService: FormGroupService,
    private eformsService: EformsService,
    private router: Router,
    public dataFilterService: DataFilterSubskrypcjeService,
    private encryptionService: EncryptionService
    ) {
      super();
    }

  ngOnInit(): void {
    this.initSterownik();
    this.initSterownikSzczegoly();
    this.initSubskrypcje();
    this.subscribeToFilter();
    this.refreshTable();
    this.wyszukiwarkaForm = this.formGroupService.getWyszukiwarkaForm();

    this.newsletterService.loading$
    .pipe(takeUntil(this.destroy$)).subscribe((val) => {
      this.tableData = null;
      this.dataFilterService.loading$.next(val);
    });
  }

  hideModal() {
    this.monitorowanieModalContainer.disableModal();
    this.wyszukiwarkaModalContainer.disableModal();
    this.odwolanieModalModalContainer.disableModal();
    this.monitorowaniePodmiotuForm = null;
    this.selectedKrs = null;
    this.selectedStatus = null;
    this.subskrybcjaId = null;
  }

  modify(element: WszystkieSubskrypcjeTabela, action: string) {
    this.saveDisabled = true;
    this.selectedKrs = element.systemId;
    this.selectedStatus = element.status;
    this.action = action;
    this.eformsService.pobierzDaneSubskrypcji(element.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(val => {
        this.monitorowaniePodmiotuForm = this.formGroupService.getMonitorowaniePodmiotuGroup();
        this.monitorowaniePodmiotuForm.get('nazwaPodmiotuSub').setValue(element.nazwaPodmiotuSub);
        if (action == 'edycja') {
          this.monitorowaniePodmiotuForm.patchValue(this.formMapService.mapSubskrypcjaDane(val))
          this.subskrybcjaId = element.id;
        }
        this.saveDisabled = false;
      });

    this.monitorowanieModalContainer.enableModal();
  }

  save(formGroup: FormGroup) {
    this.tableData = null;
    const mappedSubskrypcja = this.formMapService.mapSubskrypcja(formGroup.getRawValue(), this.selectedKrs);
    const subscription = this.action == 'edycja' ?
      this.eformsService.edytujSubskrypcje(this.subskrybcjaId, mappedSubskrypcja)
      : this.eformsService.dodajSubskrypcje(mappedSubskrypcja);
    subscription.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.newsletterService.initSubskrypcje();
    }, (error) => {
      this.newsletterService.initSubskrypcje();
    });
    this.hideModal();
    this.action = null;
  }

  saveWyszukiwarka() {
    this.wyszukiwarkaModalContainer.disableModal();
    this.otworzWyszukiwarke(this.wyszukiwarkaForm.get('encryptedKrs').value, this.wyszukiwarkaForm.get('rodzajRejestru').value);
  }

  cancelSubscription(subskrybcjaId: string) {
    this.hideModal();
    this.tableData = null;
    this.eformsService.odwolajSubskrypcje(subskrybcjaId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.newsletterService.initSubskrypcje();
      }, (error) => {
        this.newsletterService.initSubskrypcje();
      });
  }

  deleteSubscription(subskrybcjaId: string) {
    this.hideModal();
    this.tableData = null;
    this.eformsService.usunSubskrypcje(subskrybcjaId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.newsletterService.initSubskrypcje();
      }, (error) => {
        this.newsletterService.initSubskrypcje();
      });
  }

  openDialog(element: SubskrypcjeTabela, action) {
    this.subskrybcjaId = element.id;
    this.action = action;
    if (action == 'odwolanie') {
      this.odwolanieModalModalContainer.enableModal();
    } else {
      this.dialogOpened = true;
    }
  }

  confirmClosed(confirmed: boolean) {
    if (confirmed) {
      this.deleteSubscription(this.subskrybcjaId);
    }
    this.subskrybcjaId = null;
    this.action = null;
  }

  getStatusSeverity(status: StatusSubskrypcji): 'success' | 'warning' | 'error' {
    switch (status) {
      case StatusSubskrypcji.WYGASLA:
      case StatusSubskrypcji.ODWOLANA:
        return 'error';
      case StatusSubskrypcji.AKTYWNA:
        return 'success';
      case StatusSubskrypcji.WYGASAJACA:
        return 'warning';
    }
  }

  showDetails(id: string) {
    this.router.navigate([`/zdarzenia/${id}`]);
  }

  getLink($event, numerKrs: string): void {
    $event.preventDefault();
    this.eformsService.pobierzDanePodmiotu(numerKrs)
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        const encryptedKrs = this.encryptionService.encrypt(numerKrs);
        if(res.danePodmiotu.dataWpisuDoRP && res.danePodmiotu.dataWpisuDoRS) {
          this.wyszukiwarkaModalContainer.enableModal();
          this.wyszukiwarkaForm.get('encryptedKrs').setValue(encryptedKrs);
        } else if (res.danePodmiotu.dataWpisuDoRP) {
          this.otworzWyszukiwarke(encryptedKrs, 'P')
        } else if (res.danePodmiotu.dataWpisuDoRS) {
          this.otworzWyszukiwarke(encryptedKrs, 'S')
        }
      });
  }

  subscribeToFilter(): void {
    this.dataFilterService.dataFilter
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => {
          this.dataFilterService.loading$.next(false);
          return of(null);
        })
      )
      .subscribe(filtr => {
        this.tableData = null;
        this.dataFilterService.loading$.next(true);
        setTimeout(() => {
          this.filterSubskrypcje(filtr);
        }, 250);
      });
  }

  private filterSubskrypcje(filtr: SubskrypcjeFiltrModel) {
    let data = this.dataAllSub;
    if(filtr.systemId) {
      data = data.filter(x => x.systemId.includes((+filtr.systemId).toString()));
    }
    if(filtr.status?.length) {
      data = data.filter(x => filtr.status.some(s => s === x.status));
    }
    if(filtr.noweZdarzenia === 'TAK') {
      data = data.filter(x => x.noweZdarzenia?.length > 0);
    }
    if(filtr.noweZdarzenia === 'NIE') {
      data = data.filter(x => !x.noweZdarzenia?.length);
    }

    if(filtr.dataOstatniegoZdarzeniaOd) {
      const dataOstatniegoZdarzeniaOd = DateHelper.getDate(filtr.dataOstatniegoZdarzeniaOd);
      data = data.filter(x => x.ostatnieSprawdzenie && DateHelper.getDate(x.ostatnieSprawdzenie) >= dataOstatniegoZdarzeniaOd);
    }

    if(filtr.dataOstatniegoZdarzeniaDo) {
      const dataOstatniegoZdarzeniaDo = DateHelper.getDate(filtr.dataOstatniegoZdarzeniaDo);
      data = data.filter(x => x.ostatnieSprawdzenie && DateHelper.getDate(x.ostatnieSprawdzenie) <= dataOstatniegoZdarzeniaDo);
    }

    if(filtr.subskrypcjaOd) {
      const subskrypcjaOd = DateHelper.getDate(filtr.subskrypcjaOd);
      data = data.filter(x => DateHelper.getDate(x.subskrypcjaOd) >= subskrypcjaOd);
    }

    if(filtr.subskrypcjaDo) {
      const subskrypcjaDo = DateHelper.getDate(filtr.subskrypcjaDo);
      data = data.filter(x => DateHelper.getDate(x.subskrypcjaDo) <= subskrypcjaDo);
    }

    this.tableData = data;
    this.dataFilterService.loading$.next(false);
  }

  private refreshTable(): void {
    this.newsletterService.selectedTabIndex$
      .pipe(takeUntil(this.destroy$))
      .subscribe(val => {
        if(val == 0) {
          this.tableData = null;
          this.newsletterService.initSubskrypcje();
        }
      });
  }

  private otworzWyszukiwarke(encryptedKrs: string, typRejestru: string): void {
    window.open(`${environment.wyszukiwarkaUrl}/dane-szczegolowe;numerKRS=${encodeURIComponent(encryptedKrs)};typ=${typRejestru}`);
  }

  private initSterownik() {
    this.sterownik = {
      key: '',
      name: 'newsLetterSubs',
      stateStorage: 'session',
      columns: [
        {header: 'numerKrs', field: 'systemId', dataType: 'string', sortable: true},
        {header: 'nazwa', field: 'nazwaPodmiotuSub', dataType: 'string', sortable: true},
        {header: 'noweZdarzenia', field: 'noweZdarzenia', dataType: 'string', sortable: true},
        {header: 'dataOstatniegoZdarzenia', field: 'ostatnieZdarzenie', dataType: 'string', sortable: true},
        {header: 'subskrypcjaOd', field: 'subskrypcjaOd', dataType: 'string', sortable: true},
        {header: 'subskrypcjaDo', field: 'subskrypcjaDo', dataType: 'string', sortable: true},
        {header: 'statusSubskrypcji', field: 'statusKod', dataType: 'string', sortable: true},
        {header: 'powiadomieniaEmail', field: 'powiadomienieEmail', dataType: 'string', sortable: true},
        {field: 'actions', header: 'dzialania', dataType: 'string'}
      ],
      paginator: {
        rowsPerPageOptions: [10, 20, 50],
        rows: 10,
      },
      rowExpansion: {
        dataKey: 'id'
      }
    };
  }

  private initSterownikSzczegoly() {
    this.sterownikSzczegoly = {
      key: '', columns: [
        {header: 'dataZdarzenia', field: 'dataZdarzenia', dataType: 'string'},
        {header: 'sygnaturaSprawy', field: 'sygnatura', dataType: 'string'},
        {header: 'typZdarzenia', field: 'zdarzenie', dataType: 'string'},
        {header: 'numerWpisu', field: 'numerWpisu', dataType: 'string'}
      ]
    };
  }

  private initSubskrypcje() {
    this.newsletterService.subskrypcjeUzytkownika$
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => {
          this.dataFilterService.loading$.next(false);
          return of([]);
        })
      )
      .subscribe(wszystkieSubskrypcje => {
        this.dataAllSub = this.formMapService.mapSubskrypcjeTabela(wszystkieSubskrypcje);
        this.tableData = this.dataAllSub;
        this.dataFilterService.runFilter(SubskrypcjeFiltr.filtrKey, this.dataFilterService.dataFilter.getValue());
        if(wszystkieSubskrypcje.length == 0) {
          this.dataFilterService.loading$.next(false);
        }
      });
  }
}
